import { transposeScale, isScaleCompatibleWith, getScaleForSampleName } from "$utils/music"; // music theory related
import { ParameterKnob } from "./ParameterKnob";
import { useSelector } from 'react-redux';
import { selectTonality } from '../store';
import { createSelector } from "@reduxjs/toolkit";

export const SampleTransposeKnob = ({instrument, parameterHandler, selectedPad, ...props}) => {
    const tonalitat = useSelector(selectTonality);
    const sampleOriginalScale = useSelector(createSelector(instrument.getDisplayParameterSelector('sound'), sound => getScaleForSampleName(sound)));
    const transpose = useSelector(parameterHandler.selector);
    const sampleTransposedScale = transposeScale(sampleOriginalScale, transpose);
    let sliceTonalitatCorrecta = isScaleCompatibleWith(sampleTransposedScale, tonalitat);
    if (sampleOriginalScale === undefined) {
        sliceTonalitatCorrecta = true  // Si no sabem la tonalitat del sample, no la marquem vermella mai
    }

    return <ParameterKnob {...props} mida="petit" parameterHandler={parameterHandler} label='Pitch' markLabelRed={!sliceTonalitatCorrecta} />
}